import { gql } from "@apollo/client";

export const GET_FEEDBACK = gql`
  query getFeedback($id: Int!) {
    feedback(appointment_id: $id) {
      page_token
    }
  }
`;

export const GET_FEEDBACK_PAGE = gql`
  query getFeedbackPage($page_token: String!) {
    feedbackPage(
      page_token: $page_token
    ) {
      id
      appointment_id
    }
  }
`;

export const UPDATE_FEEDBACK = gql`
  mutation updateFeedback(
    $id: Int!
    $connection: Int
    $professionist: Int
    $audio_video: Int
    $comment: String
  ) {
    updateFeedback(
      id: $id 
      connection: $connection 
      professionist: $professionist
      audio_video: $audio_video
      comment: $comment
    ) {
      id
    }
  }
`;

export const CREATE_FEEDBACK = gql`
  mutation createFeedback($id: Int!) {
    createFeedback(appointment_id: $id) {
     page_token
    }
  }
`;
